<template>
  <button
    v-if="this.activePage * this.docsPerPage < this.docsCount"
    @click="handleClick"
    type="button"
    class="link-button link-button--full link-button--dark link-button--no-arrow"
    aria-label="Next results"
  >
  {{ label }}
  </button>
</template>

<script>
export default {
  name: "pagination",
  components: {},
  props: {
    docsCount: {
      type: Number,
    },
    docsPerPage: {
      type: Number,
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      activePage: null,
    };
  },
  methods: {
    handleClick() {
      this.activePage += 1;
      this.updateFilter();
    },
    updateFilter() {
      const args = {
        pagination: {
          value: this.activePage > 0 ? this.activePage : null,
          handler: this.filterHandler,
        },
      };

      this.$emit("updateFilter", args);
    },
    filterHandler(docs) {
      const endIndex = this.activePage * this.docsPerPage;

      return docs.slice(0, endIndex);
    },
    setDefaultState() {
      this.activePage = 1;
      this.updateFilter();
    },
  },
  mounted() {
    this.setDefaultState();
  }
};
</script>
